import React, { useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ListContainer, Button } from "./CriptoWallets.styles";
import CriptoWalletForm from "./CriptoWallets.form";
import CriptoWalletList from "./CriptoWallets.list";
import {
  setIsFormMode,
  setIsEditMode,
  clearForm,
  setCryptoWallets,
  setSelectedWallet,
} from "./CriptoWallet.slice";
import AuthContext from "../../context/AuthContext";

const CriptoWallets = ({
  formValues,
  handleChange,
  errors,
  touched,
  readOnly = false,
}) => {
  const dispatch = useDispatch();
  const [selectedWalletIndex, setSelectedWalletIndex] = useState(null);
  const { isFormMode, selectedWallet } = useSelector(
    (state) => state.criptoWallet
  );

  const { token } = useContext(AuthContext);

  const currentWallets = useMemo(
    () => formValues?.crypto_wallets || [],
    [formValues?.crypto_wallets]
  );

  useEffect(() => {
    if (currentWallets.length > 0) {
      dispatch(setCryptoWallets(currentWallets));
    }
  }, [currentWallets, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearForm());
    };
  }, [dispatch]);

  const handleAddNew = () => {
    dispatch(setIsFormMode(true));
    dispatch(setIsEditMode(false));
    dispatch(setSelectedWallet(null));
  };

  const handleCancelForm = () => {
    dispatch(setIsFormMode(false));
    dispatch(setIsEditMode(false));
    dispatch(setSelectedWallet(null));
    setSelectedWalletIndex(null);
  };

  const updateFormWallets = (newWallets) => {
    const event = {
      target: {
        name: "crypto_wallets",
        value: newWallets,
      },
    };
    handleChange(event);
  };

  const handleSetDefaultWallet = (index) => {
    const newWallets = currentWallets.map((wallet, i) => ({
      ...wallet,
      is_default: i === index,
    }));
    updateFormWallets(newWallets);
    dispatch(setCryptoWallets(newWallets));
  };

  const handleAddWallet = (walletData) => {
    const isFirstWallet = currentWallets.length === 0;
    const newWallet = {
      ...walletData,
      is_default: isFirstWallet,
    };

    const newWallets = [...currentWallets, newWallet];
    updateFormWallets(newWallets);
    dispatch(setCryptoWallets(newWallets));
  };

  const handleUpdateWallet = (walletData) => {
    const newWallets = currentWallets.map((wallet, index) =>
      index === selectedWalletIndex ? walletData : wallet
    );
    updateFormWallets(newWallets);
    setSelectedWalletIndex(null);
    dispatch(setCryptoWallets(newWallets));
  };

  const handleDeleteWallet = (indx) => {
    const newWallets = currentWallets.filter((wallet, index) => index !== indx);
    updateFormWallets(newWallets);
    dispatch(setCryptoWallets(newWallets));
    setSelectedWalletIndex(null);
  };

  return (
    <div>
      {!isFormMode && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h3>Crypto Wallets</h3>
          {!readOnly && (
            <Button variant="contained" color="primary" onClick={handleAddNew}>
              Add New Wallet
            </Button>
          )}
        </div>
      )}

      {isFormMode && (
        <CriptoWalletForm
          wallet={selectedWallet}
          onCancel={handleCancelForm}
          token={token}
          onSave={selectedWallet ? handleUpdateWallet : handleAddWallet}
        />
      )}
      {!isFormMode && currentWallets.length > 0 && (
        <ListContainer>
          <CriptoWalletList
            readOnly={readOnly}
            wallets={currentWallets}
            onEdit={(wallet, index) => {
              setSelectedWalletIndex(index);
              dispatch(setSelectedWallet(wallet));
              dispatch(setIsFormMode(true));
              dispatch(setIsEditMode(true));
            }}
            onDelete={handleDeleteWallet}
            onSetDefault={handleSetDefaultWallet}
          />
        </ListContainer>
      )}

      {errors?.crypto_wallets && touched?.crypto_wallets && (
        <div style={{ color: "red", marginTop: "8px", fontSize: "0.75rem" }}>
          {errors.crypto_wallets}
        </div>
      )}
    </div>
  );
};

export default CriptoWallets;
